// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/lightBG.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --header-height: 3rem;
  --nav-width: 68px;
  --first-color: #6d28d9;
  --second-color: #6e3ac2;
  --first-color-light: #fdfdfd;
  --white-color: #f7f6fb;
  --light-gray: #948f8f;
  --light-blue: #3b91f6;
  --body-font: "Roboto", sans-serif;
  --normal-font-size: 1rem;
  --z-fixed: 100;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Roboto", sans-serif;
}

.ml-auto {
  margin-left: auto !important;
  @media (max-width: 991px) { 
    margin: auto !important;
  }
}

.mr-2 {
  margin-right: 0.5rem !important;
}

.mr-3 {
  margin-right: 1rem !important;
}

.mr-4 {
  margin-right: 4rem !important;
}

.centered-content {
  height: 80vh;
  width: 100%;
  margin: 0;
  display: flex;
}

.primary-btn {
  background-color: var(--first-color);
  outline: none;
  border: none;
}

.primary-btn:hover {
  background-color: var(--second-color);
  outline: none;
  border: none;
}

.cursor-pointer {
  cursor: pointer !important;
}
.login {
  min-height: 100vh;
}

.bg-image {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  height: 100%;
  padding: 4rem 3.5rem;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  @media (max-width: 575px) {
    background-image: none;
    padding: 0;
  }
}

.login-content {
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  padding: 0.5rem 1.5rem;
  width: 90%;
  /* max-width: 100%; */
  @media (max-width: 575px) {
    width: 100%;
  }
}

.bold-text {
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px; /* 133.333% */
}

.login-heading {
  font-weight: 300;
}

.btn-login {
  font-size: 0.9rem;
  letter-spacing: 0.05rem;
  padding: 0.75rem 1rem;
}

.action-btn {
  /* display: flex; */
  padding: 9px 0px;
  justify-content: center;
  align-items: center;
  width: 100%;
  border: none;
  outline: none;
}

.action-btn-primary {
  border-radius: 9999px;
  background: #cfb577;
}

.action-btn-secondary {
  border-radius: 9999px;
  border: 1px solid #cfb577 !important;
}

.wallet-btn span {
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
}

.main {
  padding: 46px 33px 32px 31px;
  gap: 30px;
  border-radius: 16px;
  border: 1px solid #bbb4a4;
  @media (max-width: 575px) {
    border: none;
    padding: 20px 16px;
  }
}
.title {
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
}

.content {
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.step-width {
  width: 130px;
}

.step {
  display: flex;
  width: 53px;
  padding: 10px;
  flex-direction: column;
  justify-content: center !important;
  align-items: center;
  gap: 10px;
  border-radius: 32px;
}

.step-division-line {
  width: 98.02px;
  height: 2px;
  background: var(--light-gray);
  margin-top: 1.4rem;
}

.password-section-p {
  padding: 48px 155px 111px 154px !important;
}

.light-gray {
  color: var(--light-gray);
}

.typography-1 {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.light-blue {
  color: var(--light-blue);
}

.secure-input {
  width: 84px;
  height: 35px;
  padding: 10px;
  text-align: center;
  @media (max-width: 575px) { 
    width: 100%;
  }
}

.alerting {
  filter: blur(3.5px);
  /* background: rgba(0, 0, 0, 0.65); */
}

.overlay {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 1;
  color: #fff;
  font-size: 16px;
  text-align: center;
  justify-content: center;
  background-color: #000;
  opacity: 0.65;
  height: 100%;
  border-radius: 16px;
}

.total-oslo {
  display: flex;
  height: 138px;
  /* padding: 0px 88px; */
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  border: 1px solid #bbb4a4;
  background: linear-gradient(
    180deg,
    #caad68 0%,
    rgba(202, 173, 104, 0.22) 100%
  );
}

.send-recieved-btn-section {
  display: flex;
  padding: 8px;
  flex-direction: row;
  align-items: flex-start;
  gap: 10px;
  border-radius: 10px;
  border: 1px solid #948f8f;
  justify-content: center;
}

.oslo-btn {
  display: flex;
  flex-direction: row;
  width: 173px;
  height: 36px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  border-radius: 8px;
}

.active-oslo-btn {
  background: #cfb577;
  color: #fff;
}

.inactive-oslo-btn {
  border: 1px solid #cfb577;
}

.stats-card {
  display: flex;
  /* width: 100%; */
  height: 101.077px;
  padding: 18.22px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 10.932px;
  /* margin-inline: 3px; */
  @media (max-width: 768px) {
    margin-bottom: 0.5rem
  }
  @media (max-width: 575px) {
    margin-bottom: 0.5rem
  }
}

.total-transition-light {
  border: 1.822px solid #c7a5e8;
  background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.37) 0%,
      rgba(255, 255, 255, 0.37) 100%
    ),
    linear-gradient(
      180deg,
      rgba(87, 7, 167, 0.75) 0%,
      rgba(47, 65, 229, 0.3) 100%
    );
}

.total-sent-light {
  border: 1.822px solid #30f7eb;
  background: linear-gradient(
    180deg,
    rgba(48, 247, 235, 0.75) 0%,
    rgba(59, 180, 248, 0.75) 100%
  );
}

.total-recieved-light {
  border: 1.822px solid #f2da0a;
  background: linear-gradient(
    180deg,
    rgba(242, 218, 10, 0.75) 0%,
    rgba(252, 136, 30, 0.47) 100%
  );
}

.total-successful-light {
  border: 1.822px solid #44e529;
  background: linear-gradient(
    180deg,
    rgba(68, 229, 41, 0.45) 0%,
    rgba(13, 185, 123, 0.45) 100%
  );
}
.total-failed-light {
  border: 1.822px solid #eb0202;
  background: linear-gradient(
    180deg,
    rgba(236, 62, 62, 0.45) 0%,
    rgba(254, 85, 85, 0.45) 100%
  );
}

.table-header th {
  text-align: center !important;
  background: #e2d5b5 !important;
}

.table-header td {
  font-size: 14px;
}

.left-border-radius {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.right-border-radius {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

.success-status {
  color: #37BC21;
}

.failed-status {
  color: #EB0202;
}

.pass-px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
  @media (max-width: 575px) {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}

.address-book-link {
  color: #d2a63b;
  font-weight: 600;
 margin-right: 1.5rem;
 @media (max-width: 575px) {
  margin-right: 0.8rem !important;
}
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,iCAAiC;EACjC,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;EAC5B;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,SAAS;EACT,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,aAAa;EACb,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,yDAA6C;EAC7C,YAAY;EACZ,oBAAoB;EACpB,4BAA4B;EAC5B,0BAA0B;EAC1B;IACE,sBAAsB;IACtB,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,UAAU;EACV,qBAAqB;EACrB;IACE,WAAW;EACb;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB;IACE,YAAY;IACZ,kBAAkB;EACpB;AACF;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB;IACE,WAAW;EACb;AACF;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,UAAU;EACV,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB;;;;GAIC;AACH;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB;IACE;EACF;EACA;IACE;EACF;AACF;;AAEA;EACE,6BAA6B;EAC7B;;;;;;;;;KASG;AACL;;AAEA;EACE,6BAA6B;EAC7B;;;;GAIC;AACH;;AAEA;EACE,6BAA6B;EAC7B;;;;GAIC;AACH;;AAEA;EACE,6BAA6B;EAC7B;;;;GAIC;AACH;AACA;EACE,6BAA6B;EAC7B;;;;GAIC;AACH;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B;IACE,2BAA2B;IAC3B,0BAA0B;EAC5B;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;CACjB,oBAAoB;CACpB;EACC,+BAA+B;AACjC;AACA","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n:root {\n  --header-height: 3rem;\n  --nav-width: 68px;\n  --first-color: #6d28d9;\n  --second-color: #6e3ac2;\n  --first-color-light: #fdfdfd;\n  --white-color: #f7f6fb;\n  --light-gray: #948f8f;\n  --light-blue: #3b91f6;\n  --body-font: \"Roboto\", sans-serif;\n  --normal-font-size: 1rem;\n  --z-fixed: 100;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.ml-auto {\n  margin-left: auto !important;\n  @media (max-width: 991px) { \n    margin: auto !important;\n  }\n}\n\n.mr-2 {\n  margin-right: 0.5rem !important;\n}\n\n.mr-3 {\n  margin-right: 1rem !important;\n}\n\n.mr-4 {\n  margin-right: 4rem !important;\n}\n\n.centered-content {\n  height: 80vh;\n  width: 100%;\n  margin: 0;\n  display: flex;\n}\n\n.primary-btn {\n  background-color: var(--first-color);\n  outline: none;\n  border: none;\n}\n\n.primary-btn:hover {\n  background-color: var(--second-color);\n  outline: none;\n  border: none;\n}\n\n.cursor-pointer {\n  cursor: pointer !important;\n}\n.login {\n  min-height: 100vh;\n}\n\n.bg-image {\n  background-image: url(\"./assets/lightBG.png\");\n  height: 100%;\n  padding: 4rem 3.5rem;\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  @media (max-width: 575px) {\n    background-image: none;\n    padding: 0;\n  }\n}\n\n.login-content {\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 32px;\n  padding: 0.5rem 1.5rem;\n  width: 90%;\n  /* max-width: 100%; */\n  @media (max-width: 575px) {\n    width: 100%;\n  }\n}\n\n.bold-text {\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 32px; /* 133.333% */\n}\n\n.login-heading {\n  font-weight: 300;\n}\n\n.btn-login {\n  font-size: 0.9rem;\n  letter-spacing: 0.05rem;\n  padding: 0.75rem 1rem;\n}\n\n.action-btn {\n  /* display: flex; */\n  padding: 9px 0px;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  border: none;\n  outline: none;\n}\n\n.action-btn-primary {\n  border-radius: 9999px;\n  background: #cfb577;\n}\n\n.action-btn-secondary {\n  border-radius: 9999px;\n  border: 1px solid #cfb577 !important;\n}\n\n.wallet-btn span {\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 24px; /* 150% */\n}\n\n.main {\n  padding: 46px 33px 32px 31px;\n  gap: 30px;\n  border-radius: 16px;\n  border: 1px solid #bbb4a4;\n  @media (max-width: 575px) {\n    border: none;\n    padding: 20px 16px;\n  }\n}\n.title {\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 32px;\n}\n\n.content {\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n}\n\n.step-width {\n  width: 130px;\n}\n\n.step {\n  display: flex;\n  width: 53px;\n  padding: 10px;\n  flex-direction: column;\n  justify-content: center !important;\n  align-items: center;\n  gap: 10px;\n  border-radius: 32px;\n}\n\n.step-division-line {\n  width: 98.02px;\n  height: 2px;\n  background: var(--light-gray);\n  margin-top: 1.4rem;\n}\n\n.password-section-p {\n  padding: 48px 155px 111px 154px !important;\n}\n\n.light-gray {\n  color: var(--light-gray);\n}\n\n.typography-1 {\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.light-blue {\n  color: var(--light-blue);\n}\n\n.secure-input {\n  width: 84px;\n  height: 35px;\n  padding: 10px;\n  text-align: center;\n  @media (max-width: 575px) { \n    width: 100%;\n  }\n}\n\n.alerting {\n  filter: blur(3.5px);\n  /* background: rgba(0, 0, 0, 0.65); */\n}\n\n.overlay {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  z-index: 1;\n  color: #fff;\n  font-size: 16px;\n  text-align: center;\n  justify-content: center;\n  background-color: #000;\n  opacity: 0.65;\n  height: 100%;\n  border-radius: 16px;\n}\n\n.total-oslo {\n  display: flex;\n  height: 138px;\n  /* padding: 0px 88px; */\n  justify-content: center;\n  align-items: center;\n  border-radius: 16px;\n  border: 1px solid #bbb4a4;\n  background: linear-gradient(\n    180deg,\n    #caad68 0%,\n    rgba(202, 173, 104, 0.22) 100%\n  );\n}\n\n.send-recieved-btn-section {\n  display: flex;\n  padding: 8px;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 10px;\n  border-radius: 10px;\n  border: 1px solid #948f8f;\n  justify-content: center;\n}\n\n.oslo-btn {\n  display: flex;\n  flex-direction: row;\n  width: 173px;\n  height: 36px;\n  padding: 10px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  border-radius: 8px;\n}\n\n.active-oslo-btn {\n  background: #cfb577;\n  color: #fff;\n}\n\n.inactive-oslo-btn {\n  border: 1px solid #cfb577;\n}\n\n.stats-card {\n  display: flex;\n  /* width: 100%; */\n  height: 101.077px;\n  padding: 18.22px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border-radius: 10.932px;\n  /* margin-inline: 3px; */\n  @media (max-width: 768px) {\n    margin-bottom: 0.5rem\n  }\n  @media (max-width: 575px) {\n    margin-bottom: 0.5rem\n  }\n}\n\n.total-transition-light {\n  border: 1.822px solid #c7a5e8;\n  background: linear-gradient(\n      0deg,\n      rgba(255, 255, 255, 0.37) 0%,\n      rgba(255, 255, 255, 0.37) 100%\n    ),\n    linear-gradient(\n      180deg,\n      rgba(87, 7, 167, 0.75) 0%,\n      rgba(47, 65, 229, 0.3) 100%\n    );\n}\n\n.total-sent-light {\n  border: 1.822px solid #30f7eb;\n  background: linear-gradient(\n    180deg,\n    rgba(48, 247, 235, 0.75) 0%,\n    rgba(59, 180, 248, 0.75) 100%\n  );\n}\n\n.total-recieved-light {\n  border: 1.822px solid #f2da0a;\n  background: linear-gradient(\n    180deg,\n    rgba(242, 218, 10, 0.75) 0%,\n    rgba(252, 136, 30, 0.47) 100%\n  );\n}\n\n.total-successful-light {\n  border: 1.822px solid #44e529;\n  background: linear-gradient(\n    180deg,\n    rgba(68, 229, 41, 0.45) 0%,\n    rgba(13, 185, 123, 0.45) 100%\n  );\n}\n.total-failed-light {\n  border: 1.822px solid #eb0202;\n  background: linear-gradient(\n    180deg,\n    rgba(236, 62, 62, 0.45) 0%,\n    rgba(254, 85, 85, 0.45) 100%\n  );\n}\n\n.table-header th {\n  text-align: center !important;\n  background: #e2d5b5 !important;\n}\n\n.table-header td {\n  font-size: 14px;\n}\n\n.left-border-radius {\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n}\n\n.right-border-radius {\n  border-top-right-radius: 8px;\n  border-bottom-right-radius: 8px;\n}\n\n.success-status {\n  color: #37BC21;\n}\n\n.failed-status {\n  color: #EB0202;\n}\n\n.pass-px-5 {\n  padding-right: 3rem !important;\n  padding-left: 3rem !important;\n  @media (max-width: 575px) {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n}\n\n.address-book-link {\n  color: #d2a63b;\n  font-weight: 600;\n margin-right: 1.5rem;\n @media (max-width: 575px) {\n  margin-right: 0.8rem !important;\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
